import React, { useEffect, useState } from "react";
import { Col, Row, DatePicker, Form, FormInstance, Select, Tag, Spin } from 'antd';
import dayjs from "dayjs";

import { IErroApi } from "../../../Interfaces/Interfaces";

import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../utils/messages";

import { IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import { hasText } from "../../../utils/utilsFunctions";
import { IDirigenteExcepcional } from "../Componentes/InterfaceDirigenteExcepcional";
import { postPessoaJuridica } from "../../../services/apiCad";
import { obterFuncaoPorTipoObjeto, obterObjetosDirigenteExcepcional } from "./EnumsParaDirigenteExcepcional";

interface IProps {
  form: FormInstance<any>;
  entidades: IEntidade[];
  csObjeto: number;
  setCsObjeto: React.Dispatch<React.SetStateAction<number>>;
  setMatriculaEfpc: React.Dispatch<React.SetStateAction<string>>;
  dadosDirigenteExcepcional?: IDirigenteExcepcional;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 : Histórico;
}

const { Option } = Select;
const DirigenteExcepcionalPerfil = ({ form, entidades, csObjeto, setCsObjeto, setMatriculaEfpc, manter, dadosDirigenteExcepcional }: IProps) => {

  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [cnpjReceitaFederal, setCnpjReceitaFederal] = useState<string>()

  const [funcoes, setFuncoes] = useState<any[]>([]);

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi );
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");
    }
  }, [erroApi])

  useEffect(() => {
    if (hasText(cnpjReceitaFederal)) {
      cadastroAutomaticoPessoaJuridica();
    }
    setCnpjReceitaFederal(undefined);

  }, [cnpjReceitaFederal])

  useEffect(() => {
    const funcoesNewValues = obterFuncaoPorTipoObjeto(csObjeto);
    setFuncoes(funcoesNewValues);

    if (csObjeto !== 0 && csObjeto !== form?.getFieldValue("csObjeto")) {
      form.setFieldsValue({
        funcao: undefined,
        csFuncao: undefined,
      });
    }
  }, [csObjeto])

  const handlerObjeto = async (value: any) => {
    form.setFieldsValue({
      objeto: value.children,
      csObjeto: value.key,
    });
    setCsObjeto(Number(value.key));

    // LIMPA FUNÇÕES CASO JÁ ESTEJAM PREENCHIDOS
    form.setFieldsValue({
      funcao: undefined,
      csFuncao: undefined,
    });
  };

  const handlerEntidade = async (value: any) => {
    form.setFieldsValue({
      sigla: value.children,
      matriculaEfpc: value.key,
    });
    setMatriculaEfpc(value.key);
  };

  const handlerFuncao = async (value: any) => {
    form.setFieldsValue({
      funcao: value.children,
      csFuncao: value.key,
    });
  };

  const cadastroAutomaticoPessoaJuridica = async () => {
    setTipLoading("Cadastro automático de pessoa Jurídica ...");

    // console.log(cnpjReceitaFederal);
    if (!cnpjReceitaFederal) return;
    await postPessoaJuridica(cnpjReceitaFederal).then((response) => {
      setLoading(false);

      if (response?.data?.cnpj) {
        form.setFieldsValue({
          razaoSocial: response?.data?.razaoSocial,
          nuCnpj: response.data.cnpj,
        });
      }

      successMessage(
        `Pessoa Jurídica ${response?.data?.razaoSocial.toUpperCase()} cadastrada com Sucesso de Forma automática.`
      );

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };

  return (
    <>
      <Spin spinning={loading} tip={tipLoading}>

        <Row>
          <Col xs={2} xl={2} style={{ display: manter === 1 || manter === 9 ? 'none' : 'inline' }}>
            <Form.Item label="Situação"
              labelCol={{ span: 24 }}
              colon={false}
            >
              <Tag color={dadosDirigenteExcepcional?.situacaoVigencia ? "geekblue" : "volcano"} key={dadosDirigenteExcepcional?.idDirExcepcional}>
                {dadosDirigenteExcepcional?.situacaoVigencia && dadosDirigenteExcepcional.situacaoVigencia ? "ATIVO" : "INATIVO"}
              </Tag>
            </Form.Item>
          </Col>


          <Col xs={24} xl={10}>
            <Form.Item label="Objeto"
              name="objeto"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "A informação do objeto é obrigatória",
                },
              ]}
            >
              <Select
                disabled={manter === 1 ? false : true}
                showSearch
                filterOption
                optionFilterProp='children'
                // placeholder=''
                onChange={(_, index) => {
                  handlerObjeto(index);
                }}
              >
                {obterObjetosDirigenteExcepcional().map((e: any) => (
                  <Option key={e.csObjeto} value={e.objeto}>
                    {e.objeto}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} xl={10}>
            <Form.Item label="Função"
              name="funcao"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "A informação da função é obrigatória",
                },
              ]}
            >
              <Select
                disabled={manter === 1 ? false : true}
                showSearch
                filterOption
                optionFilterProp='children'
                // placeholder=''
                onChange={(_, index) => {
                  handlerFuncao(index);
                }}
              >
                {funcoes?.map((e: any) => (
                  <Option key={e.csFuncao} value={e.funcao}>
                    {e.funcao}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} xl={10}>
            <Form.Item label="Entidade"
              name="sigla"
              colon={false}
              rules={[
                {
                  required: true,
                  message: "A entidade é obrigatória",
                },
              ]}
            >
              <Select
                disabled={manter === 1 ? entidades.length === 1 : true}
                showSearch
                filterOption
                optionFilterProp='children'
                placeholder='Selecione a entidade'
                onChange={(_, index) => {
                  handlerEntidade(index);
                }}
              >
                {entidades?.map((e: IEntidade) => (
                  <Option key={e.matricula} value={e.matricula}>
                    {e.sigla}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={8} xl={6}>
            <Form.Item label="Data Inicial de Atuação"
              name="dtInicioAtuacao"
              colon={false}
              style={{ flexDirection: "column", alignItems: "flex-start" }}
              rules={[
                {
                  required: true,
                  message: "Campo obrigatório",
                },
              ]}
            >
              <DatePicker
                disabled={manter === 1 ? false : true}
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
                placeholder="Selecionar Data"
              />
            </Form.Item>
          </Col>

          <Col xs={8} xl={6}>
            <Form.Item label="Data Final de Atuação"
              name="dtFimAtuacao"
              colon={false}
              style={{ flexDirection: "column", alignItems: "flex-start" }}
              rules={[
                {
                  validator: async (_, endDatetime) => {
                    let startDatetime = form.getFieldValue("dtInicioAtuacao");
                    if (endDatetime && startDatetime) {
                      endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                      startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                      if (endDatetime <= startDatetime) {
                        return Promise.reject(
                          "Data de final de atuação deve ser maior do que à data inicial"
                        );
                      }
                    }
                  },
                },
              ]}
            >
              <DatePicker
                disabled={manter === 2 || manter === 9 ? true : false}
                format={"DD/MM/YYYY"}
                style={{ width: "100%" }}
                placeholder="Selecionar Data"
              />
            </Form.Item>
          </Col>
        </Row>
      </Spin>

    </>
  )
};

export default DirigenteExcepcionalPerfil;